import pLimit from 'p-limit';

import type { FilesComponentSchema } from '@iconik-io/iconik-api/src/services/files';
import { parseMetadataToComponents } from '@iconik-io/uploader/src/utils/parse_component_metadata';

import { readFile } from '../components/modals/format_confirm_proxy/utils';

const limit = pLimit(1);

export async function readFileMetadataWithLimit(
  file: File,
): Promise<FilesComponentSchema[] | undefined> {
  const metadata = await limit(async () => readFileMetadata(file));

  return metadata;
}

export async function readFileMetadata(
  file: File,
): Promise<FilesComponentSchema[] | undefined> {
  const metadata = await readFile(file);

  if (!metadata) {
    return undefined;
  }

  const components = parseMetadataToComponents(metadata);

  return components;
}
